import { render } from "./SelecionarServico.vue?vue&type=template&id=afcb864e&scoped=true&ts=true"
import script from "./SelecionarServico.vue?vue&type=script&lang=ts"
export * from "./SelecionarServico.vue?vue&type=script&lang=ts"

import "./SelecionarServico.vue?vue&type=style&index=0&id=afcb864e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afcb864e"]])

export default __exports__